/**
 * Env-aware API URL helper.
 *
 * In `npm run dev` the frontend and Express live on the same origin
 * ($PORT via Vite middleware), so relative `/api/*` paths work directly.
 * In the Capacitor Android build the frontend ships inside the APK and
 * loads from `capacitor://localhost` — it must call the *deployed*
 * backend by absolute URL, configured at build time via `VITE_API_BASE`.
 *
 * Example .env.production:
 *   VITE_API_BASE=https://cardash.powerstudio.powernet.dk
 */
const API_BASE: string = ((import.meta.env.VITE_API_BASE as string | undefined) ?? "").replace(/\/+$/, "");

export function apiUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path; // already absolute
  if (!API_BASE) return path; // dev — relative
  return API_BASE + (path.startsWith("/") ? path : `/${path}`);
}

export function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  return fetch(apiUrl(path), init);
}
